import { useTranslation } from "react-i18next";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PartnerProgrammes from "@/components/PartnerProgrammes";
import PartnerApply from "@/components/PartnerApply";
import PartnerResources from "@/components/PartnerResources";
import CTABanner from "@/components/CTABanner";
import PageHero from "@/components/PageHero";
import { Handshake } from "lucide-react";

export default function PartnerFullPage() {
  const { t } = useTranslation();
  return (
    <div data-testid="page-partner-full" className="relative overflow-x-hidden">
      <Navbar />
      <PageHero
        breadcrumb={[{ label: t("pages.partner.breadcrumb1") }, { label: t("pages.partner.breadcrumb2") }]}
        pill={{ Icon: Handshake, text: t("pages.partner.pill") }}
        title={t("pages.partner.title")}
        accent={t("pages.partner.accent")}
        subline={t("pages.partner.subline")}
        primary={{ label: t("pages.partner.btnApply"), to: "#apply" }}
        secondary={{ label: t("pages.partner.btnRead"), to: "#programmes" }}
      />
      <main className="pb-16">
        <div id="programmes">
          <PartnerProgrammes />
        </div>
        <PartnerApply />
        <PartnerResources />
      </main>
      <CTABanner />
      <Footer />
    </div>
  );
}
